 export const googleAnalyticsCode = ``;